export default function SectionTitle({ title }) {
  return (
    <div className={"title"}>
      <hr className={"line"} />
      {title}
    </div>
  );
}
